import React from "react";

export default (): JSX.Element => (
  <div className="component-loading">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);
